<script>

export default {
  
};
</script>

<template>
  <div>
    <h3>
      <button v-b-modal.modal-lg class="btn btn-primary">
        Modo de verificación
      </button>
    </h3>
    <b-modal id="modal-lg" size="lg" title="Modo verificación" title-class="font-18" hide-footer>
      <slot />
    </b-modal>
  </div>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
